import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* First Grid - Company Info */}
        <div className="footer-content-top">
          <div className="footer-section company-info-horizontal">
            <div className="footer-logo-horizontal">
              <h2>VReco Energy</h2>
              <div className="logo-tagline-horizontal">Powering tomorrow's world</div>
            </div>
            <div className="company-contact-group">
              <div className="contact-item-simple">
                <span className="contact-icon">📞</span>
                <span className="contact-text">+91 982 585 7777</span>
              </div>
              <div className="contact-item-simple">
                <span className="contact-icon">✉️</span>
                <span className="contact-text">contact@vr-eco.com</span>
              </div>
            </div>
          </div>
        </div>

        {/* Second Grid - First Half and Second Half */}
        <div className="footer-content-bottom">
          {/* First Half - Company Description & Address */}
          <div className="footer-section">
            <h3>About VReco Energy</h3>
            <p className="company-description-footer">
              Leading renewable energy infrastructure solutions for a sustainable future. 
              Committed to excellence in wind and solar energy projects across Gujarat and beyond.
            </p>
            <div className="office-address">
              <h3>Our Office</h3>
              <p>
                📍 O-5, Kanaknidhi Complex,<br />
                Nanpura, Surat, Gujarat - 395001
              </p>
            </div>
          </div>
          
          {/* Second Half - Services, Quick Links & Social Links */}
          <div className="footer-links-group">
            {/* Services Section */}
            <div className="footer-section">
              <h3>Our Services</h3>
              <ul className="footer-links">
                <li><Link to="/services">Wind Turbine Projects</Link></li>
                <li><Link to="/services">Solar Energy Solutions</Link></li>
                <li><Link to="/services">Hybrid Power Systems</Link></li>
                <li><Link to="/services">Infrastructure Development</Link></li>
                <li><Link to="/services">Equipment & Logistics</Link></li>
                <li><Link to="/services">Consulting Services</Link></li>
              </ul>
            </div>

            {/* Quick Links Section */}
            <div className="footer-section">
              <h3>Quick Links</h3>
              <ul className="footer-links">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/projects">Projects</Link></li>
                <li><Link to="/career">Career</Link></li>
                <li><Link to="/contact">Contact Us</Link></li>
              </ul>
            </div>
            
            {/* Social Links Section */}
            <div className="footer-section">
              <h3>Follow Us</h3>
              <div className="social-links-vertical">
                <a href="https://www.facebook.com/profile.php?id=61571393283158" aria-label="Facebook" className="social-link facebook" target="_blank" rel="noopener noreferrer">
                  <img src="/img/facebook-logo.png" alt="Facebook" className="social-logo" />
                </a>
                <a href="https://www.linkedin.com/company/108393819" aria-label="LinkedIn" className="social-link linkedin" target="_blank" rel="noopener noreferrer">
                  <img src="/img/linkedin-logo.png" alt="LinkedIn" className="social-logo" />
                </a>
                <a href="https://x.com/VrEcoEnergy" aria-label="Twitter" className="social-link twitter" target="_blank" rel="noopener noreferrer">
                  <img src="/img/twitter-logo.png" alt="Twitter" className="social-logo" />
                </a>
                <a href="https://wa.me/919825857777" aria-label="WhatsApp" className="social-link whatsapp" target="_blank" rel="noopener noreferrer">
                  <img src="/img/whatsapp-logo.png" alt="WhatsApp" className="social-logo" />
                </a>
              </div>
            </div>
          </div>
        </div>
        
        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; 2025 VReco Energy Pvt Ltd. All rights reserved.</p>
            </div>
            <div className="footer-bottom-links">
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
              <Link to="/sitemap">Sitemap</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;